var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewsCategoryBase',{attrs:{"title":{ 'zh-CN': '行业资讯', 'en-US': 'Industry News' },"route-path":"/news/industry","category":"industry"}})
}
var staticRenderFns = []

export { render, staticRenderFns }